<!-- Certificate Course CTA Ribbon Section -->
<section class="certificate-cta-ribbon">
  <div class="ribbon-container">
    <div class="ribbon-left">
      <div class="ribbon-left-content">
        <h2 class="ribbon-title">Register for Certificate Course</h2>
      </div>
    </div>
    <div class="ribbon-right">
      <div class="ribbon-buttons">
        <a routerLink="/skill-oriented-courses" class="ribbon-btn">
          Courses <i class="fa fa-chevron-right"></i>
        </a>
        <a href="https://docs.google.com/forms/d/e/1FAIpQLScc2xmDuKJ-WkweULCQxoz5kS2w3CxA9-hTOHZOZijvaDMq9g/viewform"
          target="_blank" class="ribbon-btn">
          Registration <i class="fa fa-chevron-right"></i>
        </a>
        <a href="https://swayam.gov.in/" target="_blank" class="ribbon-btn">
          SWAYAM/MOOCs <i class="fa fa-chevron-right"></i>
        </a>
      </div>
    </div>
  </div>

  <!-- Quick Nav Strip -->
  <div class="quick-nav-strip">
    <div class="quick-nav-buttons">
      <a routerLink="/student-facilities/anti-ragging" class="quick-nav-btn">
        Ragging Free Campus
      </a>
      <a routerLink="/student-life-home" class="quick-nav-btn">
        Student Life
      </a>
      <a routerLink="/best-practices-home" class="quick-nav-btn">
        Best Practices
      </a>
      <a routerLink="/faq" class="quick-nav-btn">
        FAQs
      </a>
    </div>
  </div>

</section>